import { Component, OnInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

@Component({
    selector: 'shared-nav-bar-logo',
    templateUrl: './nav-bar-logo.shared.component.html',
    styleUrls: ['./nav-bar-logo.shared.component.scss']
})
export class NavBarLogoComponent implements OnInit {
    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void { }

    public handleLogoClick($event: Event): void {
        this.controllers.routes.navToHome();
        this.controllers.filters.clearLocationsFilters();
    }
}
